<template>
  <Layout hide-route-header>
    <div class="spinner"></div>
  </Layout>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import Layout from '../../../components/Layout/index.vue';
import { Api } from '../../../api/index.ts';
import useMetaCoordinator from './useMetaCoordinator.ts';

const { enforcePageAccess } = useMetaCoordinator();

onMounted(async () => {
  const facebookAdConfig = await Api.Quickstart.getFacebookAdConfig();
  await enforcePageAccess(facebookAdConfig);
});
</script>
